<section>
  <div class="container d-flex flex-column flex-lg-row">
    <div class="side-bar-menu">
      <div class="search-filters">
        <div class="search-filters-title"> Search filters </div>
        <div class="search d-flex align-items-center order-1 order-lg-0">
          <input
            type="text"
            placeholder="Search people, interests, organizations etc"
            [(ngModel)]="searchTerm"
            name="searchTerm"
            (keyup.enter)="onSearch()"
          />
          <button (click)="onSearch()">
            <svg viewBox="0 0 18 18">
              <use href="#search" />
            </svg>
          </button>
        </div>
        <div class="select-wrapper">
          <select (change)="onSelectKind($event.target.value)">
            <option [value]="kinds.Top" [selected]="(kind$ | async) == kinds.Top">Top</option>
            <option [value]="kinds.People" [selected]="(kind$ | async) == kinds.People">People</option>
            <option [value]="kinds.Organizations" [selected]="(kind$ | async) == kinds.Organizations"
              >Organizations
            </option>
            <option [value]="kinds.Discussions" [selected]="(kind$ | async) == kinds.Discussions">Discussions</option>
            <option [value]="kinds.Groups" [selected]="(kind$ | async) == kinds.Groups">Groups</option>
            <option [value]="kinds.Clubs" [selected]="(kind$ | async) == kinds.Clubs">Clubs</option>
            <!-- <option [value]="kinds.Events" [selected]="(kind$ | async) == kinds.Events">Events</option> -->
            <!-- <option [value]="kinds.Members" [selected]="(kind$ | async) == kinds.Members">Members</option> -->
          </select>
        </div>

        <div class="filter-block" *ngIf="(kind$ | async) == kinds.People">
          <div class="filter-label">Profile type:</div>
          <mat-checkbox
            [checked]="(selectedProfileType$ | async) === profileTypes.Student"
            (change)="onProfileTypeSelect($event, profileTypes.Student)"
            >Student</mat-checkbox
          >
          <mat-checkbox
            [checked]="(selectedProfileType$ | async) === profileTypes.Educator"
            (change)="onProfileTypeSelect($event, profileTypes.Educator)"
            >Educator</mat-checkbox
          >
        </div>
        <div
          class="filter-block"
          *ngIf="((kind$ | async) == kinds.People) && (selectedProfileType$ | async) === profileTypes.Educator"
        >
          <div class="filter-label">Educator type:</div>
          <mat-checkbox
            *ngFor="let type of educatorProfileSubTypes"
            [checked]="(selectedProfileSubType$ | async) === type"
            (change)="onProfileSubTypeSelect($event, type)"
          >
            {{ type }}
          </mat-checkbox>
        </div>
        <div class="filter-block" *ngIf="(kind$ | async) == kinds.Organizations">
          <div class="filter-label">Organizations type:</div>
          <mat-checkbox
            *ngFor="let type of organizations"
            [checked]="(organizationMember$ | async) === type"
            (change)="onOrganizationSelect($event, type)"
            >{{ type }}
          </mat-checkbox>
        </div>
        <div class="filter-block" *ngIf="(kind$ | async) == kinds.Groups || (kind$ | async) == kinds.Events">
          <div class="filter-label">Age group:</div>
          <mat-checkbox
            *ngFor="let group of ageGroups"
            [checked]="(selectedAgeGroup$ | async) === group.id"
            (change)="onAgeGroupSelect($event, group.id)"
            >{{ group.title }}
          </mat-checkbox>
        </div>
        <!-- <div class="select-wrapper">
          <select name="">
            <option value="" disabled selected>Find country</option>
          </select>
        </div>
        <div class="select-wrapper">
          <select name="">
            <option value="" disabled selected>Educational institution</option>
            <option value="">People</option>
            <option value="">Organizations</option>
            <option value="">Discussions</option>
            <option value="">Groups</option>
            <option value="">Events</option>
          </select>
        </div>
        <div class="select-wrapper">
          <select name="">
            <option value="" disabled selected>Interests & associations</option>
            <option value="">People</option>
            <option value="">Organizations</option>
            <option value="">Discussions</option>
            <option value="">Groups</option>
            <option value="">Events</option>
          </select>
        </div> -->
      </div>
    </div>

    <div class="side-bar-menu side-bar-menu-mobile-submenu d-flex d-lg-none"> </div>

    <!--    {{this.clubs$ | async | json}}-->

    <ng-container [ngSwitch]="kind$ | async">
      <app-search-results-top
        *ngSwitchCase="kinds.Top"
        [top]="top$ | async"
        (profileConnect)="onProfileConnect($event)"
        (profileDisconnect)="onProfileDisconnect($event)"
        (organizationFollow)="onOrganizationSubscribe($event)"
        (organizationUnfollow)="onOrganizationUnSubscribe($event)"
        (seeMore)="onSeeMore($event)"
      ></app-search-results-top>
      <app-search-results-list
        *ngSwitchDefault
        [totalAmount]="totalAmount$ | async"
        [amountOfPages]="amountOfPages$ | async"
        [currentPage]="page"
        [people]="(people$ | async)?.items"
        [organizations]="(organizations$ | async)?.items"
        [discussions]="(discussions$ | async)?.items"
        [groups]="(groups$ | async)"
        [clubs]="(clubs$ | async)?.items"
        [events]="(events$ | async)?.items"
        [members]="(members$ | async)?.items"
        [isPeople]="(kind$ | async) == kinds.People"
        [isOrganizations]="(kind$ | async) == kinds.Organizations"
        [isDiscussions]="(kind$ | async) == kinds.Discussions"
        [isGroups]="(kind$ | async) == kinds.Groups"
        [isClubs]="(kind$ | async) == kinds.Clubs"
        [isEvents]="(kind$ | async) == kinds.Events"
        [isMembers]="(kind$ | async) == kinds.Members"
        (join)="onGroupJoin($event)"
        (subscribe)="onOrganizationSubscribe($event)"
        (unsubscribe)="onOrganizationUnSubscribe($event)"
        (connect)="onProfileConnect($event)"
        (unconnect)="onProfileDisconnect($event)"
        (remove)="onProfileDisconnect($event)"
        (setPage)="onSetPage($event)"
      ></app-search-results-list>
    </ng-container>
  </div>
</section>
